import { lazy, Suspense } from 'react';
import { useDebugStore } from '../../hooks/useDebugStore';

const DebugRecordingIndicator = lazy(() => import('./DebugRecordingIndicator'));

const DebugRecordingIndicatorGate = () => {
  const { recording } = useDebugStore();

  if (!recording) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <DebugRecordingIndicator />
    </Suspense>
  );
};

export default DebugRecordingIndicatorGate;
